export const optionalSuffix = (text: string) => `${text.trim()} (Optional)`;
